var map = {
	"./assets-delpack-stage.addup.network/images/logo_white.svg": 579,
	"./assets-edgfms.edgistify.com/images/logo_white.svg": 580,
	"./assets-meghrajexpress-stage.addup.network/images/logo_white.svg": 581,
	"./assets-smartr.kyte.app/images/logo_white.svg": 582,
	"./assets-stage.addup.network/images/logo_white.svg": 583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;